import React from "react";
import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import themes from "../../../assets/theme";
import { H2, PrimaryStyledButton } from "./Styles";
import { navigate } from "@reach/router";

const useStyles = makeStyles((theme) => ({
  subheading: {
    color: COLORS.BTN_GREEN,
    fontSize: "18px",
    margin: "10px 0 5px 0",
    fontWeight: 600,
  },
  content: {
    fontFamily: themes.fonts.primaryFontBold,
    color: COLORS.COLOR_DARK,
    fontSize: "14px",
  },
}));

function BoardOfDirectors(props) {
  const classes = useStyles();

  return (
    <ContainerPage>
      <H2
        style={{
          textAlign: "center",
          paddingTop: "50px",
          marginBottom: "40px",
        }}
      >
        Board of Directors
      </H2>

      <ProfileContainer>
        <ProfileBox>
          <ProfileImage>
            <DirectorImg
              src={require("../../../assets/images/director1.jpg")}
              alt="Justice K. Kannan"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Justice K. Kannan</h4>
            <span className={classes.content}>Independent Director</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <DirectorImg
              src={require("../../../assets/images/director2.5,cg_true")}
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>N L Rajah</h4>
            <span className={classes.content}>Founder & Director</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <DirectorImg
              src={require("../../../assets/images/director3.5,cg_true")}
              alt="Karthik Krishna"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Karthik Krishna</h4>
            <span className={classes.content}>Founder & Director</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <DirectorImg
              src={require("../../../assets/images/director4.jpg")}
              alt="Viren Nanavati"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Viren Nanavati</h4>
            <span className={classes.content}>Director</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <DirectorImg
              src={
                "https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1766137020162-e17c8a8b-92ed-4559-b939-39339f1b8128/Chandramouli.png"
              }
              alt="Dr. C. Chandramouli"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Dr. C. Chandramouli</h4>
            <span className={classes.content}>Independent Director</span>
          </ProfileName>
        </ProfileBox>
      </ProfileContainer>

      <PrimaryStyledButton
        style={{
          width: "160px",
          margin: "60px auto 40px",
          display: "block",
          padding: "12px 24px",
          fontSize: "16px",
        }}
        onClick={() => navigate("/directors")}
      >
        See More
      </PrimaryStyledButton>
    </ContainerPage>
  );
}

export default BoardOfDirectors;

const ContainerPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
  background: #f8f9fa;

  @media (max-width: 480px) {
    padding: 30px 15px;
  }
`;

export const ProfileContainer = styled.div`
  display: grid;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  gap: clamp(2rem, 4vw, 3rem);
  justify-items: center;

  @media (min-width: 1400px) {
    grid-template-columns: repeat(5, 1fr);
    gap: clamp(2.5rem, 5vw, 4rem);
  }

  i @media (min-width: 1024px) and (max-width: 1399px) {
    grid-template-columns: repeat(4, 1fr);
    max-width: 1200px;
  }

  /* Tablets: 3 columns */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(3, 1fr);
    max-width: 900px;
    gap: clamp(1.8rem, 3vw, 2.5rem);
    padding: 0 30px;
  }

  /* Small Tablets: 2 columns */
  @media (min-width: 481px) and (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: clamp(2rem, 5vw, 2.5rem);
    padding: 0 20px;
  }

  /* Mobile: 1 column */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    padding: 0 15px;
  }
`;

export const ProfileBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 280px;
  transition: transform 0.3s ease;

  @media (hover: hover) {
    &:hover {
      transform: translateY(-8px);
    }
  }
`;

export const ProfileImage = styled.div`
  width: clamp(160px, 22vw, 220px);
  height: clamp(160px, 22vw, 220px);
  border-radius: 50%;
  overflow: hidden;
  border: 5px solid #ffffff;
  background: linear-gradient(135deg, #f0f4f5 0%, #e1e8eb 100%);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  transition: all 0.4s ease;

  @media (hover: hover) {
    &:hover {
      transform: scale(1.08);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2),
        0 0 25px rgba(0, 131, 140, 0.25);
    }
  }

  @media (max-width: 480px) {
    width: clamp(140px, 45vw, 180px);
    height: clamp(140px, 45vw, 180px);
    margin-bottom: 1.2rem;
  }
`;

export const DirectorImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.5s ease;

  ${ProfileImage}:hover & {
    @media (hover: hover) {
      transform: scale(1.12);
    }
  }
`;

export const ProfileName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 480px) {
    gap: 0.4rem;
  }
`;
